import { createContext } from 'react';
import useChatRoom, { useChatRoomState } from '@/hooks/useChatRoom';

export const ChatRoomContext = createContext({} as useChatRoomState);

type ChatRoomContextProps = {
    children: JSX.Element;
};

export const ChatRoomProvider = (props: ChatRoomContextProps) => {
    const { children } = props;
    const chatroom = useChatRoom();
    return (
        <ChatRoomContext.Provider value={chatroom}>
            {children}
        </ChatRoomContext.Provider>
    );
};
